import React from "react";
import { IconExcel, IconPdf, IconPrint } from "./icons";
import Button from "./Button";

/**
 * Excel / PDF / Print: the same three buttons, the same layout, everywhere in the app.
 * The buttons are neutral (one accent per page), only the icon carries the file type color.
 * Each button is disabled when there is no data to export; pdfPrintDisabled disables only PDF and Štampa
 * (e.g. the shopping list is empty while Excel still has rows).
 */
export default function ExportButtonGroup({ onExcel, onPdf, onPrint, disabled = false, pdfPrintDisabled = false, size = "md" }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        variant="secondary"
        size={size}
        icon={IconExcel}
        iconClassName="text-success-dark dark:text-success-light"
        onClick={onExcel}
        disabled={disabled}
      >
        Excel
      </Button>
      <Button
        variant="secondary"
        size={size}
        icon={IconPdf}
        iconClassName="text-danger-dark dark:text-danger-light"
        onClick={onPdf}
        disabled={disabled || pdfPrintDisabled}
      >
        PDF
      </Button>
      <Button variant="secondary" size={size} icon={IconPrint} onClick={onPrint} disabled={disabled || pdfPrintDisabled}>
        Štampa
      </Button>
    </div>
  );
}
